var _path, _g, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1752:4750",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 13,
    width: 8,
    height: 7
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.418 13.5029H29.5698V19.2018H22.418V13.5029Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1752:4750)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6624 15.2579C26.1837 15.2579 26.6062 15.7479 26.6062 16.3507C26.6062 16.9553 26.1837 17.4441 25.6624 17.4441C25.1412 17.4441 24.718 16.9553 24.718 16.3507C24.7186 15.7479 25.1412 15.2579 25.6624 15.2579ZM22.418 19.2018H29.5699V13.5029H22.418V19.2018Z",
    fill: "#120136"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91833 6.36801L23.406 1.91743C23.5842 1.86291 23.7635 1.88769 23.9385 1.99239C24.2254 2.16585 24.4442 2.52579 24.5217 2.95697L25.1379 6.36801H8.91833ZM29.4335 12.4496V8.22693C29.4335 7.20163 28.7047 6.36715 27.8084 6.36715H26.2141L25.5647 2.77024C25.4328 2.03611 25.0397 1.42589 24.4878 1.09259C24.0559 0.832394 23.559 0.767964 23.0909 0.912311L5.61752 6.2798C5.16064 6.41919 4.75626 6.75311 4.48 7.21836L4.49375 7.22703C4.33188 7.51635 4.23438 7.85832 4.23438 8.22693V16.9503C4.94251 16.7471 5.69064 16.6338 6.46566 16.6338C10.7976 16.6338 14.3214 20.0386 14.3214 24.2241C14.3214 24.9006 14.2283 25.5641 14.0476 26.2084H27.8078C28.7041 26.2084 29.4328 25.3739 29.4328 24.3486V20.2523H21.7509C21.4571 20.2523 21.2202 20.0169 21.2202 19.7264V12.9755C21.2209 12.6843 21.4584 12.4496 21.7509 12.4496H29.4335Z",
    fill: "#EEA961"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0588 24.8429C3.71317 24.8429 3.43317 24.5654 3.43317 24.2222C3.43317 23.8796 3.7138 23.6021 4.0588 23.6021H9.1489C9.49453 23.6021 9.77454 23.8796 9.77454 24.2222C9.77454 24.5654 9.49391 24.8429 9.14827 24.8429H4.0588ZM6.6032 17.875C2.96191 17.875 0 20.7235 0 24.2244C0 27.7253 2.96129 30.5738 6.6032 30.5738C9.33699 30.5738 11.8208 28.9228 12.7845 26.4646C13.0652 25.7503 13.207 24.9963 13.207 24.2244C13.207 20.7235 10.2445 17.875 6.6032 17.875Z",
    fill: "#CF5E1D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditIcon);
export default __webpack_public_path__ + "static/media/credit-icon.10351ecf.svg";
export { ForwardRef as ReactComponent };